// Keep in sync with GraphQL ConflictType enum

export const PARTICIPANT_MAPPING_REQUIRED = 'PARTICIPANT_MAPPING_REQUIRED'
export const PROJECT_MAPPING_REQUIRED = 'PROJECT_MAPPING_REQUIRED'
export const PROCESSING_ERROR = 'PROCESSING_ERROR'
export const INVALID_ISRC = 'INVALID_ISRC'
export const PUBLISHER_MAPPING_REQUIRED = 'PUBLISHER_MAPPING_REQUIRED'
export const UNSUPPORTED_PRODUCT_TYPE = 'UNSUPPORTED_PRODUCT_TYPE'
export const UNSUPPORTED_RELEASE_TYPE = 'UNSUPPORTED_RELEASE_TYPE'
